"use strict";
// Generated from splitscript/antlr_files/Splitscript.g4 by ANTLR 4.13.2
Object.defineProperty(exports, "__esModule", { value: true });
const antlr4_1 = require("antlr4");
/**
 * This interface defines a complete listener for a parse tree produced by
 * `SplitscriptParser`.
 */
class SplitscriptListener extends antlr4_1.ParseTreeListener {
    /**
     * Enter a parse tree produced by `SplitscriptParser.program`.
     * @param ctx the parse tree
     */
    enterProgram;
    /**
     * Exit a parse tree produced by `SplitscriptParser.program`.
     * @param ctx the parse tree
     */
    exitProgram;
    /**
     * Enter a parse tree produced by `SplitscriptParser.formula`.
     * @param ctx the parse tree
     */
    enterFormula;
    /**
     * Exit a parse tree produced by `SplitscriptParser.formula`.
     * @param ctx the parse tree
     */
    exitFormula;
    /**
     * Enter a parse tree produced by the `exprAtom`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprAtom;
    /**
     * Exit a parse tree produced by the `exprAtom`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprAtom;
    /**
     * Enter a parse tree produced by the `exprPlusMinus`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprPlusMinus;
    /**
     * Exit a parse tree produced by the `exprPlusMinus`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprPlusMinus;
    /**
     * Enter a parse tree produced by the `exprBoolean`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprBoolean;
    /**
     * Exit a parse tree produced by the `exprBoolean`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprBoolean;
    /**
     * Enter a parse tree produced by the `exprComparison`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprComparison;
    /**
     * Exit a parse tree produced by the `exprComparison`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprComparison;
    /**
     * Enter a parse tree produced by the `exprPow`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprPow;
    /**
     * Exit a parse tree produced by the `exprPow`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprPow;
    /**
     * Enter a parse tree produced by the `exprTimesDiv`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprTimesDiv;
    /**
     * Exit a parse tree produced by the `exprTimesDiv`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprTimesDiv;
    /**
     * Enter a parse tree produced by the `exprParenthesis`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprParenthesis;
    /**
     * Exit a parse tree produced by the `exprParenthesis`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprParenthesis;
    /**
     * Enter a parse tree produced by the `exprSignedAtom`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    enterExprSignedAtom;
    /**
     * Exit a parse tree produced by the `exprSignedAtom`
     * labeled alternative in `SplitscriptParser.expr`.
     * @param ctx the parse tree
     */
    exitExprSignedAtom;
    /**
     * Enter a parse tree produced by `SplitscriptParser.atom`.
     * @param ctx the parse tree
     */
    enterAtom;
    /**
     * Exit a parse tree produced by `SplitscriptParser.atom`.
     * @param ctx the parse tree
     */
    exitAtom;
}
exports.default = SplitscriptListener;
